export const getTheme = (): string => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; theme=`);
  if (parts.length === 2) {
    const theme = parts.pop()?.split(';').shift();
    if (theme) return theme;
  }
  return 'darkly'; // Default theme
};

export const setTheme = (theme: string) => {
  const date = new Date();
  date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `theme=${theme};${expires};path=/`;
};
